/**
 * Shared recovery copy and action for App Router error boundaries.
 *
 * Next's `reset()` re-renders the same JS bundle. Leftover tabs after a
 * deploy keep crashing on the stale client, so the recovery action is a
 * hard reload that fetches the latest version.
 */

import { trackErrorBoundaryReloadClicked } from "@/lib/analytics/client";

export const ERROR_BOUNDARY_HEADING = "Something went wrong";
export const ERROR_BOUNDARY_COPY = "Reload to get the latest version.";
export const ERROR_BOUNDARY_ACTION_LABEL = "Reload";

export function hardReloadPage(context: "route" | "root"): void {
  // Best-effort: trackEvent try/catches internally, so a PostHog failure can
  // never block the recovery reload. window.location.pathname (not
  // usePathname) so the root boundary — which renders without a router
  // context — reports the crashed page too.
  trackErrorBoundaryReloadClicked({ context, path: window.location.pathname });
  window.location.reload();
}
